import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { ClientfinalCraService } from './../../../../../core/services/clientfinal-cra/clientfinal-cra.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  serverError,
  successAddworkfloww,
} from './../../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { EsnpermissionService } from '@core/services/esnpermission/esnpermission.service';

@Component({
  selector: 'app-add-workflowconsultant',
  templateUrl: './add-workflowconsultant.component.html',
  styleUrls: ['./add-workflowconsultant.component.css'],
})
export class AddWorkflowconsultantComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  currentStep: number = 1;
  name = [
    { id: '1', name: 'Consultant' },
    { id: '2', name: 'Responsable' },
    { id: '3', name: 'RH' },
  ];
  state = [
    { id: '1', name: 'Validé' },
    { id: '2', name: 'Rejeté' },
  ];
  list:any
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraclient: ClientfinalCraService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private roleservice: EsnpermissionService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.getAllListConsultant();
    this.getListrole()
  }
  createWorkFlowForm(data?: any) {
    return this.formBuilder.group({
      company_id_specific: [data?.company_id_specific || null],
      consultant_ids: [data?.consultant_ids || null],
      state_workflow: ['3'],
      subWorkFlowTimeSheets: this.formBuilder.array(
        Array.isArray(data?.subWorkFlowTimeSheets) &&
          data?.subWorkFlowTimeSheets.length
          ? data.subWorkFlowTimeSheets.map((item: any) =>
              this.createFormssubWorkFlows(item)
            )
          : [this.createFormssubWorkFlows()]
      ),
    });
  }
  createFormssubWorkFlows(data?: any, index?: number) {
    return this.formBuilder.group({
      name: [data ? data.name : null],
      custom_role_id: [data ? data.custom_role_id : null, [this.validateUniqueRole(index || 0)]],
      step: [data ? data.step : '1'],
      responsable_project : [data ? (data.responsable_project  === 1 ? 1 : 0) : 0]

    });
  }
  validateRoleNotEmpty(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      return value ? null : { roleEmpty: true }; // Retourne une erreur si le rôle est vide
    };
  }
  validateUniqueRole(index: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const subWorkFlows = this.formWorkFlow?.get('subWorkFlowTimeSheets') as FormArray;
      const selectedRoleId = control.value;
  
      let isDuplicate = false;
      subWorkFlows?.controls.forEach((formGroup, i) => {
        if (i !== index && formGroup.get('custom_role_id')?.value === selectedRoleId) {
          isDuplicate = true;
        }
      });
  
      return isDuplicate ? { duplicateRole: true } : null;
    };
  }
  /* create workflow general*/
  createWorkflow() {
    this.spinner.show();
    this.serviceCraclient
      .createWorkFlowForm(this.formWorkFlow.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', this.formWorkFlow.value);
          this.spinner.hide();

          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
          this.router.navigate(['/cra/workflow-Timesheet']);
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
              // Swal.fire(this.toastMessages.error);
              // this.toastr.error(this.toastMessages.error);
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }

  addsubWorkFlows() {
    const subWorkFlows = this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray;
    subWorkFlows.push(this.createFormssubWorkFlows(undefined, subWorkFlows.length));
  }
  get subWorkFlowsControls(): AbstractControl<any, any>[] {
    return (
      (this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray)?.controls ||
      []
    );
  }
  removesubWorkFlows(index: number) {
    const subWorkFlows = this.formWorkFlow.get(
      'subWorkFlowTimeSheets'
    ) as FormArray;
    if (subWorkFlows.length > 1) {
      subWorkFlows.removeAt(index);
    }
  }
  ResetForm() {
    this.formWorkFlow.reset();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  /* list consultant*/
  getAllListConsultant() {
    this.spinner.show();
    let clientFinal_id = this.localStorageService.getData('clientConnected');
    this.serviceCraclient
      .getAllconsultantclientfinal(clientFinal_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.list = res.data;
          this.listresponsablesWithDisplayName()
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  listresponsablesWithDisplayName() {
    this.list.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  // onRoleChange(index: number) {
  //   const formGroup = this.subWorkFlowsControls.at(index);
  //   const selectedRoleId = formGroup?.get('custom_role_id')?.value;
  
  //   if (selectedRoleId === 1) {
  //     formGroup?.get('custom_role_id')?.setValue(null);
  //     formGroup?.get('responsable_project')?.setValue(1);
  //   } else {
  //     formGroup?.get('responsable_project')?.setValue(0);
  //   }
  // }
  listrole: any;
  listroleWithStatic!: Array<{ id: number, name: string }>;

  getListrole() {
    this.roleservice.getlisterolesUpdate().subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data) {
          this.listrole = response.data.data;
          // this.listroleWithStatic = [
          //   { id: 1, name: 'Responsable project' },
          //   ...this.listrole
          // ];
          console.log('list roles', this.listrole ,"listroleWithStatic",this.listroleWithStatic);
        }
      },
      error: (error) => {
        console.error('Error fetching roles: ', error);
      },
    });
  }
}
